import { render, staticRenderFns } from "./RecibosCombustible.vue?vue&type=template&id=037d3441"
import script from "./RecibosCombustible.vue?vue&type=script&lang=js"
export * from "./RecibosCombustible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports